import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets window scroll to top whenever the route pathname changes.
// React Router preserves scroll across <Link> navigation by default;
// this restores standard browser-page behavior. Listens to pathname
// only (not search/hash) so query-param updates like ?canceled=1
// don't blow away the user's scroll position mid-page.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
